import { DialogDisclosure, Heading } from "@ariakit/react";
import { DialogTrigger } from "@indietabletop/appkit";
import type { ReactElement } from "react";
import { button, lacquer, superNormal } from "../../common/common.css.ts";
import { database } from "../../database.ts";
import type { Repair } from "../../engine/Repair.ts";
import type { Treatment } from "../../engine/Treatment.ts";
import { ConfirmDialog } from "../ConfirmDialog/ConfirmDialog.tsx";
import { useGitContext, useVehicleContext } from "./ModelContext.tsx";

function RemovedModelView(props: {
  overline: string;
  heading: string;
  description: string;
  revertLabel: string;
  dialog: ReactElement;
}) {
  const { overline, heading, description, revertLabel, dialog } = props;

  return (
    <div
      style={{
        display: "grid",
        gridTemplateRows: "1fr auto",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        padding: "1rem",
        maxInlineSize: "30rem",
        marginInline: "auto",
      }}
    >
      <div>
        <div className={lacquer} style={{ marginBlockEnd: "0.25rem" }}>
          {overline}
        </div>

        <Heading
          className={superNormal}
          style={{ marginBlockEnd: "0.5rem", fontSize: "2rem" }}
        >
          {heading}
        </Heading>

        <p>{description}</p>
      </div>

      <DialogTrigger>
        {dialog}

        <DialogDisclosure
          className={button({
            theme: "beige",
            size: "small",
            maxInlineSize: "auto",
          })}
        >
          {revertLabel}
        </DialogDisclosure>
      </DialogTrigger>
    </div>
  );
}

export function WriteOffView(props: { reason: Repair }) {
  const { reason } = props;
  const vehicle = useVehicleContext();

  return (
    <RemovedModelView
      overline={reason.name}
      heading={vehicle.name}
      description={reason.description}
      revertLabel="Fix up"
      dialog={
        <ConfirmDialog
          heading="Fix vehicle?"
          description={`All records of its write-off will be purged from history, and any caps spent on repairs will be refunded.`}
          submitLabel="Fix up"
          theme="red"
          onSubmit={() => {
            const next = vehicle.revertWriteOff(reason);
            return database.gangs.updateOne(next.gang.data);
          }}
        />
      }
    />
  );
}

export function InMemoriamView(props: { reason: Treatment }) {
  const { reason } = props;
  const git = useGitContext();

  return (
    <RemovedModelView
      overline={reason.name}
      heading={git.name}
      description={reason.description}
      revertLabel="Revive"
      dialog={
        <ConfirmDialog
          heading="Revive git?"
          description={`All records of their death will be purged from history, and any caps spent on healthcare will be refunded.`}
          submitLabel="Revive"
          theme="red"
          onSubmit={() => {
            const next = git.revive(reason);
            return database.gangs.updateOne(next.gang.data);
          }}
        />
      }
    />
  );
}
